import React, { Component } from 'react';
import { graphql, StaticQuery } from 'gatsby';
import { GatsbyImage } from "gatsby-plugin-image"

class PorQueIberica extends Component {
    render() {
        return(
            <div className="row iberica-row-pq-iberica">
                <div className="col-sm-12">
                    <div className="container iberica-container-pq-iberica">
                        <h2 className="iberica-h2-pq-iberica">Por Que Ibérica?</h2>
                        <ul className="iberica-ul-pq-iberica">
                           <li>Empresa 100% Brasileira;</li>
                           <li>Atendimento rápido e personalizado;</li>
                           <li>Serviços de apoio ao cliente;</li>
                           <li>Prazos de fabricação rápidos;</li>
                           <li>Serviços de pós-venda e marketing.</li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
 }

const QueryPorQueIberica = () => (
    <StaticQuery
      query={graphql`
      query PorQueIbericaQuery {
        contentfulAsset(title: {eq: "por-que-iberica-placeholder"}) {
            gatsbyImageData(quality: 100, placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
        }
    }
    `}
      render={(data) => (
        <PorQueIberica data={data} />
      )}
    />
  )

export default QueryPorQueIberica